module.exports = flarum.reg.get('flarum-tags', 'common/utils/sortTags');